<section class="aff-sec">
    <div class="aff-wrap">
        <div class="aff-back">
            <h1 class="page-title">{{'Referral Program' | translate}}</h1>

            <!--referal changes-->

            <div class="head-section">
                <div class="clearfix ico-top-divs row">
                    <div class="col-sm-6 col-md-4 col-lg-3 no-right">
                        <div class="inner-box ">


                            <div class="top-left-ico-text">
                                <p class="ico-top-text">My Referral Network Issued PIP
                                    <!-- <span class="white-right">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                              <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                            </svg>
                          </span> -->
                                </p>
                            </div>


                            <div class="clearfix table-type">


                                <div class="left-stat-icon">

                                    <img src="../../../assets/img/left-cash-icon.png">


                                </div>

                                <div class="right-icon-stats">


                                    <p class="number">
                                        <!-- {{ICOInformation?.Sale}} -->
                                        {{networkIssuedPPTL | currency : 'crypto'}}
                                        <span class="dollar">PIP</span>
                                    </p>
                                    <!-- <p class="total-text">{{ 'ISSUED VALUE ' | translate}}</p> -->


                                </div>


                            </div>




                        </div>
                    </div>

                    
                    



                    <div class="col-sm-12 col-md-4 col-lg-3 no-right">
                        <div class="inner-box">
                            <div class="top-left-ico-text">
                                <p class="ico-top-text">Countries in My Referral Network
                                    <!-- <span class="white-right">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="47px" height="6px">
                              <image x="0px" y="0px" width="47px" height="6px" xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAGCAQAAAD5jQ/ZAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfiBwQRJhUZ/fXmAAAAW0lEQVQoz2P8/5YBBgQYGBmIBd8YfhJQwcTAyFDA8J92oPA/AwvR7iUNfGWIYtjEQCPj3zGEM+xhYKCN8Q8ZQhlOQ5gsDO/gwoSi9i/DF4Z/BA2/yxDJcBfGAQDslWyKBW4N8QAAAABJRU5ErkJggg==" />
                            </svg>
                          </span> -->
                                </p>
                            </div>

                            <div class="clearfix table-type">


                                <div class="left-stat-icon">

                                    <img src="../../../assets/img/globe.png" width="100">


                                </div>

                                <div class="right-icon-stats">


                                    <p class="number">{{referredCountries}}

                                    </p>
                                    <p class="total-text" *ngIf="referredCountries <= 1">COUNTRY
                                    </p>
                                    <p class="total-text" *ngIf="referredCountries > 1">{{ 'Countries' | translate}}
                                    </p>


                                </div>


                            </div>

                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-3">
                        <div class="inner-box ">

                            <div class="top-left-ico-text">
                                <p class="ico-top-text">My Referral PIP Bonuses
                                </p>
                            </div>

                            <div class="clearfix table-type soft-hard-box">
                                <div class="row bg-row">
                                    <div class="col some-padding text-centered">
                                        <div class="mt-4">
                                            <div class="d-flex flex-column justify-content-center">
                                                <div class="d-flex flex-row justify-content-center mb-0 mt-3">
                                                    <p class="number pt-0">{{earningValues('pptl') | currency : 'crypto'}}</p>
                                                </div>
                                                <div class="d-flex flex-row justify-content-center">
                                                    <p class="ml-2 dollar pt-0">PIP</p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>


                                    <div class="col  text-centered">
                                        <div class="d-flex flex-column justify-content-center mt-4">
                                            <div class="d-flex flex-row justify-content-center mb-0 mt-3">
                                                <p class="number pt-0">$  
                                                    {{earningValues('usdt') | currency:'crypto'}}
                                                </p>
                                            </div>
                                            <div class="d-flex flex-row justify-content-center">
                                                <p class="ml-2 dollar pt-0">AUD VALUE</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>



                            </div>




                        </div>
                    </div>



                </div>
            </div>

            <!---->





            <div class="row1">
                <div class="row">
                    <div class="col-lg-6 right-7">
                        <div class="white-back referral-pd">
                            <!-- <div class="pos-rltv">

                                <div class="pos-left">
                                    <h6 class="aff-h2">{{'Discription' | translate}}

                                    </h6>

                                </div>


                            </div>
                            <div class="clear"></div>
                            <div>
                                <p class="aff-p1">
                                    {{ 'Every user will earn 2% of the investment of their referrals using their code' |
                                    translate}}
                                </p>
                            </div> -->


                            <!-- <hr class="saperator" /> -->

                            <!-- <div class="pos-rltv negate-margin">

                                <h6 class="aff-h2 some-extra-margin">select commission type</h6>
                                <div class="checksimg ">
                                    <div class="pos-rltv">
                                        <div class="pos-left2">
                                            <p class="checkp">
                                                <input type="radio" name="cpaRevenue" class='v-checkbox' id="test1" (change)="cpaActionClick()" />
                                                <label for="test1">CPA ( Cost per action ) - 5% in Cash or Crypto or 7% in
                                                    Tokens </label>
                                            </p>
                                            <p class="checkp pad-btm">
                                                <input type="radio" name="cpaRevenue" class='v-checkbox' id="test2" (change)="revenueActionClick()" />
                                                <label for="test2">REVENUE SHARE - 25% of fee</label>
                                            </p>

                                        </div>
                                        <div class="pos-left3">

                                        </div>
                                    </div>
                                    <div class="clear"></div>
                                </div>
                            </div> -->

                            <div>
                                <div class="">
                                    <div class="padding-change">
                                        <p class="aff-link pt-0 mb-0">{{'Your Referral link:'| translate}}</p>
                                    </div>
                                    <div class=" padding-change2 affiliate-text-field">
                                        <input id="aff-link-1" class="aff-link-in" type="text" readonly
                                            value="{{affiliateLink}}">
                                        <div class="copy-link-section">
                                            <button class="copy-af-link" (click)="copyToClipboard('aff-link-1')">


                                                <p class="p-15 copy-add">
                                                    <i class="far fa-copy"></i>

                                                </p>


                                            </button>
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-1 col-md-1 col-xs-12 padding-change centering-btn">
                                        
                                    </div> -->
                                </div>
                                <div class="">
                                    <div class="padding-change">
                                        <p class="aff-link mb-0">{{ 'Your Referral Code:' | translate}}</p>
                                    </div>
                                    <div class=" padding-change2 affiliate-text-field">
                                        <input id="aff-code-1" class="aff-link-in" type="text" readonly
                                            value="{{affiliateCode}}">
                                        <div class="copy-link-section">
                                            <button class="copy-af-link" (click)="copyToClipboard('aff-code-1')">


                                                <p class="p-15 copy-add">
                                                    <i class="far fa-copy"></i>

                                                </p>


                                            </button>
                                        </div>
                                    </div>
                                    <!-- <div class="col-lg-1 col-md-1 col-xs-12 padding-change centering-btn">
                                            <button class="copy-af-link" (click)="copyToClipboard('aff-code-1')">
    
    
                                                <p class="p-15 copy-add">
                                                    <i class="far fa-copy"></i>
    
                                                </p>
    
    
                                            </button>
                                        </div> -->
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 left-7">
                        <div class="">
                            <div class="white-back">

                                <div class="pos-rltv">

                                    <div class="pos-left">
                                        <h6 class="aff-h2">TOP REFERRERS GLOBALLY

                                        </h6>
                                    </div>



                                </div>

                                <div class="table-responsive">


                                    <p class="no-record" *ngIf="noTopAffilliates">No Data Found</p>

                                    <table class="table table-striped affiliates-detail" *ngIf="!noTopAffilliates">
                                        <thead>
                                            <tr>
                                                <td class="text-uppercase text-center">
                                                    <p>Username</p>
                                                </td>
                                                <td class="text-uppercase text-center">
                                                    <p>Country</p>
                                                </td>
                                                <!-- <td class="text-uppercase text-center">
                                                    <p>Total Licensee's Referred</p>
                                                </td> -->
                                            </tr>
                                        </thead>
                                        <tbody *ngIf="!topRefersLoader">
                                            
                                            <tr *ngFor="let referral of topReferrals">
                                                <td class="text-center">
                                                    <p class="earners-name">{{referral?.username}}</p>
                                                </td>
                                                <td class="text-center">
                                                    <p class="earnings">{{referral?.country}}</p>
                                                </td>
                                                <!-- <td class="text-center">
                                                    <p class="earnings">{{referral?.referred}}</p>
                                                </td> -->
                                                <!-- <td>
                                                    <p class="earnings">{{referral?.AmountInUsd | currency:'crypto'}}
                                                        PPTL </p>
                                                    <div class="progress-table-wrap">
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar"
                                                                aria-valuenow="100" aria-valuemin="0"
                                                                aria-valuemax="100"
                                                                [style.width.%]="referral.percentage">

                                                            </div>
                                                        </div>
                                                    </div>
                                                </td> -->
                                            </tr>


                                        </tbody>

                                        <tbody *ngIf="topRefersLoader">
                                            <tr >
                                                <td colspan="12">
                                                    <div  class="custom-loader">
                                                        <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                        preserveAspectRatio="xMidYMid">
                                                        <g transform="rotate(208.756 50 50)">
                                                            <animateTransform attributeName="transform" type="rotate"
                                                                repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                                dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                                            </animateTransform>
                                                            <path fill="#85ffbd"
                                                                d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                                            </path>
                                                            <path fill="#316598"
                                                                d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                                            </path>
                                                            <path fill="#a4bcc2"
                                                                d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                                            </path>
                                                        </g>
                                                    </svg>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>

                                    <div class='pagination-bottom pt-2' *ngIf="!topRefersLoader">

                                        <pagination-controls *ngIf="referralPSize < paginationNumber" responsive="true" previousLabel=""
                                          nextLabel="" (pageChange)="changePageForTopReferrals($event)"></pagination-controls>
                          
                                        
                                        <ul class="no-visibility-2 d-none">
                                          <li
                                            *ngFor="let item of topReferrals | paginate: { itemsPerPage: referralPSize, currentPage: topReferalCurrentPage, totalItems: paginationNumber }">
                                            {{item}}
                                          </li>
                                        </ul>
                            
                                      </div>
                                </div>


                            </div>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-6 d-md-block d-lg-none d-xl-none left-7">



                        <div class="height-div">
                            <div class="white-back2">
                                <div class="pos-rltv">

                                    <div class="pos-left">
                                        <h6 class="aff-h2">my affiliates

                                        </h6>

                                    </div>


                                </div>
                                <div class="clear"></div>

                                <div class="topp">
                                    <div class="table-responsive">
                                        <p class="no-record" *ngIf="noMyAffilliates">No Data Found</p>
                                        <table class="table my-tbl table-striped" *ngIf="!noMyAffilliates">
                                            <thead>
                                                <tr>
                                                    <td>

                                                        <p class="top-aff-th left-aligned">Name</p>


                                                    </td>
                                                    <td>

                                                        <p class="top-aff-th  center-aligned">time</p>


                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody class="">

                                                <tr *ngFor="let affiliate of myAffilliates">
                                                    <td class="text-capitalize">{{affiliate?.UserName}}</td>
                                                    <td class="center-aligned">{{affiliate?.CreatedOnUTC}} </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>




                            </div>

                            <!-- <div>
                                <img class="tbl-img" src="../../../assets/img/tbl-img.png">
                            </div> -->


                        </div>


                    </div>
                </div>
            </div>

            <!--tables section-->

            <h1 class="page-title">My Referral Network </h1>

            <div class="table-section">
                <div class="piptel-transaction-history ">
                    <div class="header header-whte">
                        <p class="transaction-txt">Level 1: My Direct Referrals including any Placement</p>

                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="f-bold">Member Full name</th>
                                        <th class="f-bold">Member Username</th>
                                        <th class="f-bold">Join Date</th>
                                        <!-- <th class="f-bold">Licence Type</th> -->
                                        <th class="f-bold">Registration Country</th>
                                        <!-- <th class="f-bold">Amount of Direct Referrals</th> -->
                                        <th class="f-bold">Total AUD Purchase Value</th>
                                        <th class="f-bold">Pip Cryptos Issued </th>
                                        <th class="f-bold">My Bonus Pip Cryptos Earned</th>

                                    </tr>
                                </thead>
                                <tbody *ngIf="tableLoader1">
                                    <tr >
                                        <td colspan="12">
                                            <div  class="custom-loader">
                                                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <g transform="rotate(208.756 50 50)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                        dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                                    </animateTransform>
                                                    <path fill="#85ffbd"
                                                        d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                                    </path>
                                                    <path fill="#316598"
                                                        d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                                    </path>
                                                    <path fill="#a4bcc2"
                                                        d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                                    </path>
                                                </g>
                                            </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader1 && levelOneData?.data.rows.length == 0" >
                                    <tr>
                                        <td colspan="12" class="no-data-tbl">no data to display</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader1 && levelOneData?.data.rows.length > 0">
                                    <tr *ngFor="let data of levelOneData?.data.rows">
                                        <td>{{data.fullName}}</td>
                                        <td>{{data.username}}</td>
                                        <td>{{data.joinDate | date:'yyyy-MM-dd'}}</td>
                                        <!-- <td>{{data.licence}}</td> -->
                                        <td>{{data.country}}</td>
                                        <!-- <td>{{levelOneData?.data.totalRecords}}</td> -->
                                        <td>{{data.audPurchase  | currency:'crypto'}}</td>
                                        <td>{{data.pptlIssued   | currency:'crypto'}}</td>
                                        <td>{{data.bonusEarned  | currency:'crypto'}}</td>
                                    </tr>   
                                </tbody>
                            </table>

                            <div class='pagination-bottom pt-2' *ngIf="!tableLoader1  && levelOneData?.data.rows.length > 0">

                                <pagination-controls *ngIf="tableOneSize < tableOneCount" responsive="true" previousLabel=""
                                  nextLabel="" (pageChange)="changePageForTable1($event)"></pagination-controls>
                  
                                
                                <ul class="no-visibility-2 d-none">
                                  <li
                                    *ngFor="let item of levelOneData | paginate: { itemsPerPage: tableOneSize, currentPage: tableOneCurrentPage, totalItems: tableOneCount }">
                                    {{item}}
                                  </li>
                                </ul>
                    
                              </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="table-section">
                <div class="piptel-transaction-history ">
                    <div class="header header-whte">
                        <p class="transaction-txt">Level 2:  Team Referrals</p>

                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="f-bold tbl-row-head-pd">Referrer Full name</th>
                                        <th class="f-bold tbl-row-head-pd">Member Full name</th>
                                        <th class="f-bold tbl-row-head-pd">Member Username</th>
                                        <th class="f-bold tbl-row-head-pd">Join Date</th>
                                        <!-- <th class="f-bold tbl-row-head-pd">Licence Type</th> -->
                                        <th class="f-bold tbl-row-head-pd">Registration Country</th>
                                        <!-- <th class="f-bold tbl-row-head-pd">Amount of Direct Referrals</th> -->
                                        <th class="f-bold tbl-row-head-pd">Total AUD Purchase Value</th>
                                        <th class="f-bold tbl-row-head-pd">Pip Cryptos Issued </th>
                                        <th class="f-bold tbl-row-head-pd">My Bonus Pip Cryptos Earned</th>

                                    </tr>
                                </thead>
                                <tbody *ngIf="tableLoader2">
                                    <tr >
                                        <td colspan="12">
                                            <div  class="custom-loader">
                                                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <g transform="rotate(208.756 50 50)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                        dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                                    </animateTransform>
                                                    <path fill="#85ffbd"
                                                        d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                                    </path>
                                                    <path fill="#316598"
                                                        d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                                    </path>
                                                    <path fill="#a4bcc2"
                                                        d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                                    </path>
                                                </g>
                                            </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader2 && levelTwoData?.data.rows.length == 0" >
                                    <tr>
                                        <td colspan="12" class="no-data-tbl">no data to display</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader2  && levelTwoData?.data.rows.length > 0" >
                                   
                                    
                                    <tr *ngFor="let data of levelTwoData?.data.rows">
                                        <td>{{data.referrer}}</td>
                                        <td>{{data.fullName}}</td>
                                        <td>{{data.username}}</td>
                                        <td>{{data.joinDate | date:'yyyy-MM-dd'}}</td>
                                        <!-- <td>{{data.licence}}</td> -->
                                        <td>{{data.country}}</td>
                                        <!-- <td>{{levelTwoData?.data.totalRecords}}</td> -->
                                        <td>{{data.audPurchase  | currency:'crypto'}}</td>
                                        <td>{{data.pptlIssued  | currency:'crypto'}}</td>
                                        <td>{{data.bonusEarned  | currency:'crypto'}}</td>
                                    </tr>     
                                </tbody>
                            </table>

                            <div class='pagination-bottom pt-2' *ngIf="!tableLoader2 && levelTwoData?.data.rows.length > 0">

                                <pagination-controls *ngIf="tableTwoSize < tableTwoCount" responsive="true" previousLabel=""
                                  nextLabel="" (pageChange)="changePageForTable2($event)"></pagination-controls>
                  
                                
                                <ul class="no-visibility-2 d-none">
                                  <li
                                    *ngFor="let item of levelTwoData | paginate: { itemsPerPage: tabletwoSize, currentPage: tableTwoCurrentPage, totalItems: tableTwoCount }">
                                    {{item}}
                                  </li>
                                </ul>
                    
                              </div>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-section">
                <div class="piptel-transaction-history ">
                    <div class="header header-whte">
                        <p class="transaction-txt">Level 3:  Team Referrals</p>

                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="f-bold tbl-row-head-pd">Sponsor Full name</th>
                                        <th class="f-bold tbl-row-head-pd">Member Full name</th>
                                        <th class="f-bold tbl-row-head-pd">Member Username</th>
                                        <th class="f-bold tbl-row-head-pd">Join Date</th>
                                        <!-- <th class="f-bold tbl-row-head-pd">Licence Type</th> -->
                                        <th class="f-bold tbl-row-head-pd">Registration Country</th>
                                        <!-- <th class="f-bold tbl-row-head-pd">Amount of Direct Referrals</th> -->
                                        <th class="f-bold tbl-row-head-pd">Total AUD Purchase Value</th>
                                        <th class="f-bold tbl-row-head-pd">Pip Cryptos Issued </th>
                                        <th class="f-bold tbl-row-head-pd">My Bonus Pip Cryptos Earned</th>

                                    </tr>
                                </thead>
                                <tbody *ngIf="tableLoader3">
                                    <tr >
                                        <td colspan="12">
                                            <div  class="custom-loader">
                                                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <g transform="rotate(208.756 50 50)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                        dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                                    </animateTransform>
                                                    <path fill="#85ffbd"
                                                        d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                                    </path>
                                                    <path fill="#316598"
                                                        d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                                    </path>
                                                    <path fill="#a4bcc2"
                                                        d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                                    </path>
                                                </g>
                                            </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader3 && levelThreeData?.data.rows.length == 0" >
                                    <tr>
                                        <td colspan="12" class="no-data-tbl">no data to display</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!tableLoader3 && levelThreeData?.data.rows.length > 0">
                                    <tr *ngFor="let data of levelThreeData?.data.rows">
                                        <td class="tbl-row-pd">{{data.referrer}}</td>
                                        <td class="tbl-row-pd">{{data.fullName}}</td>
                                        <td class="tbl-row-pd">{{data.username}}</td>
                                        <td class="tbl-row-pd">{{data.joinDate | date:'yyyy-MM-dd'}}</td>
                                        <!-- <td class="tbl-row-pd">{{data.licence}}</td> -->
                                        <td class="tbl-row-pd">{{data.country}}</td>
                                        <!-- <td class="tbl-row-pd">{{levelThreeData?.data.totalRecords}}</td> -->
                                        <td class="tbl-row-pd">{{data.audPurchase  | currency:'crypto'}}</td>
                                        <td class="tbl-row-pd">{{data.pptlIssued  | currency:'crypto'}}</td>
                                        <td class="tbl-row-pd">{{data.bonusEarned  | currency:'crypto'}}</td>
                                    </tr>     
                                </tbody>
                            </table>

                            <div class='pagination-bottom pt-2' *ngIf="!tableLoader3 && levelThreeData?.data.rows.length > 0">

                                <pagination-controls *ngIf="tableThreeSize < tableThreeCount" responsive="true" previousLabel=""
                                  nextLabel="" (pageChange)="changePageForTable3($event)"></pagination-controls>
                  
                                
                                <ul class="no-visibility-2 d-none">
                                  <li
                                    *ngFor="let item of levelThreeData | paginate: { itemsPerPage: tablethreeSize, currentPage: tableThreeCurrentPage, totalItems: tableThreeCount }">
                                    {{item}}
                                  </li>
                                </ul>
                    
                              </div>

                        </div>
                    </div>
                </div>
            </div>

            <!--end table section-->


            <div class="row">

                <div class="col-md-12">

                    <div class="all-white">


                        <div class="pos-rltv heading-left">

                            <div class="aff-earnings">

                                <h6>{{'REFER EARNINGS' | translate}}

                                </h6>

                            </div>


                        </div>


                        <div class="download-csv" *ngIf="!noAffiliateEarners">
                            <div class="heading-right right-aligned" (click)="downloadCSV()">
                                <h1 class="download-csv">{{'Download as' | translate}} CSV
                                    <span class="download-image">
                                        <svg width="10px" height="12px" viewBox="0 0 10 12" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">

                                            <defs></defs>
                                            <g id="Page-1" stroke="none" stroke-width="1" fill="none"
                                                fill-rule="evenodd">
                                                <g id="Buy-tokens" transform="translate(-1020.000000, -856.000000)"
                                                    fill="#2097D4">
                                                    <g id="Activity" transform="translate(277.000000, 820.000000)">
                                                        <path
                                                            d="M753,40.2355536 L750.143495,40.2355536 L750.143495,36 L745.856505,36 L745.856505,40.2355536 L743,40.2355536 L748.002232,45.1733569 L753,40.2355536 Z M743,48 L753,48 L753,46.5866784 L743,46.5866784 L743,48 Z"
                                                            id="download-button"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                </h1>
                            </div>
                        </div>


                        <div class="clear"></div>



                        <div class="table-responsive aff-earners-div">



                            <table class="table table-striped affiliates-detail">

                                <thead>
                                    <tr>
                                        <td class="text-uppercase text-center">
                                            <p>{{'Currency' | translate}}</p>
                                        </td>
                                        <td class="text-uppercase text-center">
                                            <p>{{'AMOUNT CONTRIBUTED' | translate}}</p>
                                        </td>
                                        <!-- <td class="text-uppercase text-right">
                                            <p>{{'AMOUNT INVESTED IN MXN' | translate}}</p>
                                        </td> -->
                                        <td class="text-uppercase text-center">
                                            <p>{{'USERNAME' | translate}}</p>
                                        </td>
                                        <td class="text-uppercase text-center">
                                            <p>{{'TIME' | translate}}</p>
                                        </td>
                                        <!-- <td class="text-uppercase text-right">
                                            <p>{{'EARNING IN MXN' | translate}} (2%)</p>
                                        </td> -->
                                        <td class="text-uppercase text-center">
                                            <p>{{'EARNING IN FRU' | translate}}</p>
                                        </td>


                                    </tr>
                                </thead>

                                <tbody *ngIf="affiliatesLoader">
                                    <tr >
                                        <td colspan="12">
                                            <div  class="custom-loader">
                                                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <g transform="rotate(208.756 50 50)">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                                        dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                                    </animateTransform>
                                                    <path fill="#85ffbd"
                                                        d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                                    </path>
                                                    <path fill="#316598"
                                                        d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                                    </path>
                                                    <path fill="#a4bcc2"
                                                        d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                                    </path>
                                                </g>
                                            </svg>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- <tbody *ngIf="!affiliatesLoader && !levelTwoData" >
                                    <tr>
                                        <td colspan="12" class="no-data-tbl">no data to display</td>
                                    </tr>
                                </tbody> -->
                                <tbody *ngIf="!affiliatesLoader && !totalAffiliatesArray">
                                    <tr>
                                        <td colspan="12" class="text-center">
                                            <p class="no-record">{{'No Refer Earners!' | translate}}</p>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody *ngIf="!affiliatesLoader && totalAffiliatesArray">
                                 

                                    <tr *ngFor="let affiliate of totalAffiliatesArray">

                                        <!-- <td class="img-width-table v-middle text-center">

                                            <div class="coin-image">
                                                <img *ngIf="affiliate.CurrencyType=='USD'"
                                                    src="../../../assets/img/dollar-icon-green.png" alt="dollar-icon">
                                                <img *ngIf="affiliate.CurrencyType=='MXN'"
                                                    src="../../../assets/img/dollar-icon.png" alt="mxn-icon">
                                                <img *ngIf="affiliate.CurrencyType=='LTC'"
                                                    src="../../../assets/img/ltc-left.png" alt="ltc-icon">
                                                <img *ngIf="affiliate.CurrencyType=='BTC'" style="width: 30px"
                                                    src="../../../assets/img/btc-left.png" alt="btc-icon">
                                                <img *ngIf="affiliate.CurrencyType=='ETH'"
                                                    src="../../../assets/img/eth-left.png" alt="eth-icon">
                                                <img style="padding-top: 12px;" *ngIf="affiliate.CurrencyType=='FRU'"
                                                    src="../../../assets/img/fav.png" alt="xchge-icon">

                                            </div>



                                        </td> -->

                                        <td class="text-uppercase text-center">
                                            <p class="amounts-text">{{affiliate.currency | currency:'crypto'}}</p>
                                        </td>
                                        <td class="text-center">
                                            <p class="amounts-text">{{affiliate.amountInvested | currency: 'crypto'}}</p>
                                        </td>
                                        <!-- <td class="text-uppercase text-right">
                                            <p class="amounts-text">${{affiliate.AmountInMexican}}</p>
                                        </td> -->

                                        <td class="text-center">
                                            <p class="amounts-text">{{affiliate.userName}}</p>
                                        </td>

                                        <td class="text-center">
                                            <p class="amounts-text">{{affiliate.time | date : 'yyyy-MM-dd'}}</p>
                                        </td>

                                        <!-- <td class="text-right">
                                            <p class="amounts-text-black">{{affiliate.EarningInMexican}} MXN</p>
                                        </td> -->

                                        <td class="text-center">
                                            <p class="amounts-text-black">{{affiliate.earningInPPTL | currency:'crypto'}}
                                                PIP</p>
                                        </td>

                                    </tr>



                                </tbody>



                            </table>



                            <div class='pagination-table clearfix'
                                *ngIf="affiliateEarningsPageSize < totalAffiliateEarningsRecords">

                                <ul class="no-visibility">
                                    <li
                                        *ngFor="let item of totalAffiliatesArray | paginate: { itemsPerPage: affiliateEarningsPageSize, currentPage: affiliateEarningsPageNumber, totalItems: totalAffiliateEarningsRecords }">
                                        {{item}}</li>
                                </ul>

                                <pagination-controls responsive="true" previousLabel="" nextLabel=""
                                    (pageChange)="changePageNumber($event)"></pagination-controls>

                            </div>


                        </div>

                        <div class="bg-table clearfix" *ngIf="!affiliatesLoader && totalAffiliatesArray">


                            <ul class="clearfix total-row">

                                <li>
                                    <p class="total-head">{{'Total'|translate}} :</p>
                                </li>

                                <!-- <li>
                                    <p class="total-values">$ {{totalEarningInUSD  | currency:'fait'}}</p>
                                </li> -->

                                <li>
                                    <p class="total-values">{{totalEarningInPPTL | currency:'crypto'}} PIP </p>
                                </li>

                            </ul>


                        </div>


                    </div>

                </div>


            </div>

            <div class="row">

                <div class="col-md-8 col-lg-8 col-sm-7 col-xs-12">

                    <div class="graph-wrapper">

                        <div class="graph-loader" id="graphLoader">
                            <div class="center-loader">
                                <svg class="lds-comets" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 100 100"
                                    preserveAspectRatio="xMidYMid">
                                    <g transform="rotate(208.756 50 50)">
                                        <animateTransform attributeName="transform" type="rotate"
                                            repeatCount="indefinite" values="360 50 50;0 50 50" keyTimes="0;1"
                                            dur="2.3s" keySplines="0.5 0.5 0.5 0.5" calcMode="spline">
                                        </animateTransform>
                                        <path fill="#85ffbd"
                                            d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z">
                                        </path>
                                        <path fill="#316598"
                                            d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z">
                                        </path>
                                        <path fill="#a4bcc2"
                                            d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z">
                                        </path>
                                    </g>
                                </svg>
                            </div>
                        </div>


                        <div class="posReltv">
                            <div class="row">

                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <p class="aff-h2">
                                        {{'REVENUE FROM THE REFERRAL FOR THE RESPECTIVE USERS' | translate}}
                                    </p>
                                </div>
                                <div class="col-lg-6 col-md-12 col-sm-12  scndHlf">
                                    <div class="rytAlgnmnt">
                                        <label class="marryt20">
                                            {{'Show' | translate}}:
                                        </label>
                                        <ul class="affiliate-graph-ul">

                                            <li class="affiliate-active-li" (click)="getGraphByFilter('DAY')">
                                                {{ 'DAYS' | translate}}
                                            </li>
                                            <li class="" (click)="getGraphByFilter('WEEK')">
                                                {{ 'WEEKS' | translate}}
                                            </li>
                                            <li class="" (click)="getGraphByFilter('MONTH')">
                                                {{ 'MONTHS' | translate}}
                                            </li>
                                        </ul>
                                    </div>



                                </div>



                            </div>

                            <div class="relative" *ngIf="noGraphData">
                                <p class="no-data">{{'NO DATA FOUND' | translate}}</p>
                            </div>


                            <div class="graph-div" *ngIf="!noGraphData">


                                <div class="">
                                    <p class="affiliate-chart-lft-lbl">
                                        {{ 'EARNING' | translate}} ($)
                                    </p>
                                </div>


                                <canvas id="aff-chart" baseChart [datasets]="lineChartData" [labels]="lineChartLabels"
                                    [options]="lineChartOptions" [colors]="lineChartColors" [legend]="lineChartLegend"
                                    [chartType]="lineChartType"></canvas>


                                <p class="affiliate-chart-btm-lbl">
                                    {{ 'TIME' | translate}}
                                </p>

                            </div>



                        </div>

                    </div>


                </div>


                <div class="col-md-4 col-lg-4 col-sm-5 col-xs-12">


                    <div class="height-div">
                        <div class="white-back2">
                            <div class="pos-rltv">

                                <div class="pos-left">
                                    <h6 class="aff-h2">{{'MY REFERRALS' | translate}}

                                    </h6>

                                </div>


                            </div>
                            <div class="clear"></div>

                            <div class="topp">
                                <div class="table-responsive">
                                    <p class="no-record" *ngIf="noMyAffilliates">{{ 'No Data Found' | translate}}</p>
                                    <table class="table my-tbl table-striped" *ngIf="!noMyAffilliates">
                                        <thead>
                                            <tr>
                                                <td>

                                                    <p class="top-aff-th left-aligned">{{'Name' | translate}}</p>


                                                </td>
                                                <td>

                                                    <p class="top-aff-th left-aligned">{{'Time' | translate}}</p>


                                                </td>
                                            </tr>
                                        </thead>
                                        <tbody class="">

                                            <tr *ngFor="let affiliate of myAffilliates">
                                                <td class="text-capitalize blue-text"
                                                    style="text-align: left !important">{{affiliate?.UserName}}</td>
                                                <td class="text-capitalize blue-text"
                                                    style="text-align: left !important">{{affiliate?.CreatedOnUTC}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>



                                <div class='pagination-bottom'>

                                    <ul class="no-visibility">
                                        <li
                                            *ngFor="let item of myAffilliates | paginate: { itemsPerPage: myAffiliatesPageSize, currentPage: myAffiliatesPageNumber, totalItems: totalAffiliatesForUser }">
                                            {{item}}</li>
                                    </ul>

                                    <pagination-controls *ngIf="myAffiliatesPageSize < totalAffiliatesForUser"
                                        responsive="true" previousLabel="" nextLabel=""
                                        (pageChange)="changePageNumberForMyAffiliates($event)"></pagination-controls>




                                </div>

                                <div class="clear"></div>

                            </div>




                        </div>




                    </div>


                </div>


            </div>

            <div class="row2">
                <div class="row">

                    <!-- <div class="col-lg-6 ">    d-md-none d-sm-none d-xs-none d-lg-block d-none left-7
                    
                        <div class="height-div">
                            <div class="white-back2">
                                <div class="pos-rltv">

                                    <div class="pos-left">
                                        <h6 class="aff-h2">My Referrals

                                        </h6>

                                    </div>


                                </div>
                                <div class="clear"></div>

                                <div class="topp">
                                    <div class="table-responsive">
                                        <p class="no-record" *ngIf="noMyAffilliates">No Data Found</p>
                                        <table class="table my-tbl table-striped" *ngIf="!noMyAffilliates">
                                            <thead>
                                                <tr>
                                                    <td>

                                                        <p class="top-aff-th left-aligned">Name</p>


                                                    </td>
                                                    <td>

                                                        <p class="top-aff-th  center-aligned">time</p>


                                                    </td>
                                                    <td>

                                                        <p class="top-aff-th center-aligned">bonus</p>

                                                    </td>
                                                </tr>
                                            </thead>
                                            <tbody class="">

                                                <tr *ngFor="let affiliate of myAffilliates">
                                                    <td class="text-capitalize">{{affiliate?.Name}}</td>
                                                    <td class="center-aligned">{{affiliate?.Date}} </td>
                                                    <td class="text-uppercase center-aligned">$ {{affiliate?.AmountInUsd}}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>




                            </div>

                            <div>
                                <img class="tbl-img" src="../../../assets/img/my affiliates bg.png">
                            </div>


                        </div>
                    </div> -->
                </div>
            </div>


        </div>
    </div>
</section>